export const FOLLOWING_STATUS = Object.freeze({
  following: 'following',
  pending: 'pending',
  error: 'error',
  canFollow: 'can_follow',
  canRequest: 'can_request'
});

export const FOLLOW_ACTIONS = Object.freeze({
  add: 'add',
  followRequested: 'follow_requested',
  following: 'following',
  requestToFollow: 'request_to_follow',
  follow: 'follow'
});

export default { FOLLOWING_STATUS, FOLLOW_ACTIONS };
